module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aujVgl/tc-custom/9781631940132.jpg?1703687201374",
      "alt": "This image is the cover for the book Written in Blood, Inspector Barnaby Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Written in Blood, Inspector Barnaby Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When a visiting author is suspected of murder, the case is hardly open and shut in this English village mystery novel by the author of "), _c('i', [_vm._v("Death in Disguise")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Midsomer Worthy’s Writers’ Circle has never had much luck in attracting guest speakers. Consequently, there is much surprise when best-selling novelist Max Jennings accepts their invitation. But the members are even more surprised by their secretary, Gerald Hadleigh, who furiously objects to hosting Jennings—and offers no explanation."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Surprise turns into a variety of responses when Hadleigh is found dead the morning after Jennings’ visitation. Chief Inspector Barnaby soon determines that the key to solving the murder will lie with the illustrious Jennings. There’s only one problem: the famous author has disappeared.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caroline Graham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Caroline Graham is a British mystery novelist and screenwriter best known for the \"Inspector Barnaby\" mystery series which became the basis for the long-running \"Midsomer Murders\" TV series")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0